import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psxtra-tag',
  templateUrl: './psxtra-tag.component.html',
  styleUrls: ['./psxtra-tag.component.scss']
})
export class PsxtraTagComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
